<div class="o-modal--alert o-modal--warning o-modal--medium" id="mod-can-req">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalEditSaadelegatePortal.title' | translate }}</label>
    </div>
    <div class=" o-modal__body">
    </div>
    <div class=" o-modal__footer">
        <div>
            <button mat-button mat-dialog-close (click)="Close()"  class="btn btn--default" ><u> {{ 'ModalEditSaadelegatePortal.buttonCancel' | translate }}</u></button>
            <button mat-button   (click)="Accept()" class="btn btn--primary" >{{ 'ModalEditSaadelegatePortal.buttonEdit' | translate }}</button>
        </div>
    </div>
</div>